export default "__VITE_ASSET__Boj3unbx__"